import { render, staticRenderFns } from "./CreateSingleBrandDashboard.vue?vue&type=template&id=d07c6754&scoped=true&"
import script from "./CreateSingleBrandDashboard.vue?vue&type=script&lang=js&"
export * from "./CreateSingleBrandDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CreateSingleBrandDashboard.vue?vue&type=style&index=0&id=d07c6754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07c6754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
